<div class="app-body">
    <main class="main d-flex align-items-center">
        <div class="container">
            <div class="row">
                <div class="col-md-8 offset-md-2 mx-auto">
                    <form [formGroup]="form">
                        <div class="card-group">
                            <div class="card p-4">
                                <div class="card-body">
                                    <div class="logo"></div>
                                    <!-- リンクが無効・期限切れのときは依頼画面へ戻す (issue #171) -->
                                    <div *ngIf="expired" class="alert alert-danger">
                                        {{ 'shell.link_expired_prefix' | transloco }}<a [routerLink]="['/reset-password']">{{ 'shell.here' | transloco }}</a>{{ 'shell.link_expired_suffix' | transloco }}
                                    </div>
                                    <div *ngIf="changed" class="alert alert-success">
                                        {{ 'shell.password_changed_prefix' | transloco }}<a [routerLink]="['/login']">{{ 'shell.log_in_link' | transloco }}</a>{{ 'shell.password_changed_suffix' | transloco }}
                                    </div>
                                    <div formGroupName="password" *ngIf="!changed">
                                        <div class="form-group row">
                                            <label class="col-md-3 form-control-label">{{ 'route.password' | transloco }}</label>
                                            <div class="col-md-9" [ngClass]="{'has-danger':formHelper.hasErrorTooltip(form,newPassword,'password','newPassword')}" [tooltip]="'shell.password_min8' | transloco" triggers="" #newPassword="bs-tooltip" placement="right">
                                                <input type="password" class="form-control" [ngClass]="{'form-control-danger':formHelper.hasError(form, 'password','newPassword')}" formControlName="newPassword" [placeholder]="'route.password' | transloco">
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-md-3 form-control-label">{{ 'shell.password_confirm' | transloco }}</label>
                                            <div class="col-md-9" [ngClass]="{'has-danger':formHelper.hasErrorTooltip(form,confirmPassword,'password')}" [tooltip]="'shell.password_mismatch' | transloco" triggers="" #confirmPassword="bs-tooltip" placement="right">
                                                <input type="password" class="form-control" [ngClass]="{'form-control-danger':formHelper.hasError(form, 'password')}" formControlName="confirmPassword" [placeholder]="'shell.password_confirm' | transloco">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <button type="button" class="btn btn-primary btn-block" [disabled]="!form.valid" (click)="changePassword(form.value)">{{ 'shell.change_password' | transloco }}</button>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-12">
                                            {{ 'shell.login_prefix' | transloco }}<a [routerLink]="['/login']">{{ 'shell.here_link' | transloco }}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </main>
</div>
